module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/ts-loader/index.js!./life-rp.cfwidget.tsx"));
	}, "term");
}